export default __webpack_public_path__ + "static/media/F0000.f5a98ffd.png";